$ = require("jquery")

SubmitDirective = ->
  require: '^form'
  restrict: "A"
  priority: 1
  link: (scope , element , attributes, form) ->
    scope.showError = false
    scope.$watch "#{attributes.name}.$dirty", (dirty) ->
      # because we always setPristine so that the flag $dirty is not work as expected
      # we need to create another flag to simulate with dirty
      form.isDirty = true if dirty
      # keep pristine until submitted
      form.$setPristine() unless form.submitted

    form.clearForm = ->
      form.$setPristine()
      form.isDirty = false
      form.submitted = false

    element.bind "submit", (e) ->
      e.preventDefault()
      form.submitted = true
      scope.showError = true # once submitted, then show error anytime.

      fields = element.find("input:not([type=checkbox]):not([type=radio]), textarea, .gnp-date-input, .gnp-player-hdcp, select")
      angular.forEach fields, (f) ->
        f = $(f)
        fieldName = f.attr("name")
        fieldElement = form[fieldName]
        fieldElement.$setViewValue(f.val()) if !f.attr("typeahead") and !f.is("select") and !f.hasClass("gnp-player-hdcp") #typehead will open a popup autocomplete with this line
        fieldElement.$pristine = false
        fieldElement.$dirty = true

      scope.$eval(attributes.gnpSubmit) unless form.$invalid
      scope.$eval(attributes.onFormError) if form.$invalid and attributes.onFormError
      scope.$apply()
      return form.$invalid

module.exports = SubmitDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/submit-directive.coffee